export const FormItemTypes = [
  { label: 'Heading', type: 'heading', icon: 'HeadingOutlined', datatype: 'string' },
  { label: 'Sub Heading', type: 'subHeading', icon: 'ParagraphOutlined', datatype: 'string' },
  { label: 'Input', type: 'input', icon: 'TextOutlined', datatype: 'string' },
  { label: 'Text Area', type: 'textarea', icon: 'TextOutlined', datatype: 'string' },
  { label: 'Number', type: 'number', icon: 'NumbersOutlined', datatype: 'number' },
  { label: 'Dropdown', type: 'select', icon: 'DropdownOutlined', datatype: 'string' },
  { label: 'Checkbox', type: 'checkbox', icon: 'CheckboxOutlined', datatype: 'boolean' },
  { label: 'Choice', type: 'radio', icon: 'ChoiceOutlined', datatype: 'string' },
  { label: 'Slider', type: 'slider', icon: 'SliderOutlined', datatype: 'number' },
  { label: 'Rating', type: 'rating', icon: 'StarOutlined', datatype: 'number' },
  { label: 'Table', type: 'table', icon: 'LineOutlined', datatype: 'array' },
  { label: 'Date', type: 'date', icon: 'CalendarOutlined', datatype: 'date' },
  { label: 'Time', type: 'time', icon: 'LogOutlined', datatype: 'time' },
  { label: 'Yes/No', type: 'yesno', icon: 'YesnoOutlined', datatype: 'boolean' },
  { label: 'Attachment', type: 'upload', icon: 'AttachmentOutlined', datatype: 'array' },
  { label: 'Color Picker', type: 'color', icon: 'TextColorOutlined', datatype: 'string' },
  { label: 'Signature', type: 'signature', icon: 'SignatureOutlined', datatype: 'string' }
];

export const SystemFields = [
  { label: 'Peoples', type: 'user', icon: 'UsersOutlined', datatype: 'string' },
  { label: 'Invoice table', type: 'invoicetable', icon: 'LineOutlined', datatype: 'array' },
  { label: 'Customers', type: 'customer', icon: 'CustomerOutlined', datatype: 'string' },
  { label: 'Project', type: 'project', icon: 'WorkspaceOutlined', datatype: 'string' },
  { label: 'Country', type: 'country', icon: 'CountryOutlined', datatype: 'string' },
  { label: 'Priority', key: 'priority', type: 'select', icon: 'TextOutlined', datatype: 'string' },
  { label: 'Status', key: 'status', type: 'select', icon: 'TextOutlined', datatype: 'string' },
  { label: 'Epic', key: 'epic', type: 'text', icon: 'TextOutlined', datatype: 'string' },
  { label: 'Module', key: 'module', type: 'text', icon: 'TextOutlined', datatype: 'string' },
  { label: 'Component', key: 'component', type: 'text', icon: 'TextOutlined', datatype: 'string' },
  { label: 'Drive', key: 'specLink', type: 'link', icon: 'TextOutlined', datatype: 'string' },
  { label: 'Environment', key: 'environment', type: 'text', icon: 'TextOutlined', datatype: 'string' }
];



// export const systemFields = [
//   { label: 'Summary', key: 'summary', type: 'input', icon: 'TextOutlined' },
//   { label: 'Issue Type', key: 'issueType', type: 'select', icon: 'TextOutlined' },
//   { label: 'Assignee', key: 'assignee', type: 'user', icon: 'TextOutlined' },
//   { label: 'Reporter', key: 'reporter', type: 'user', icon: 'TextOutlined' },
//   { label: 'Acceptance Criteria', key: 'acceptanceCriteria', type: 'textarea', icon: 'TextOutlined' },
//   { label: 'Description', key: 'description', type: 'textarea', icon: 'TextOutlined' },
//   { label: 'Status', key: 'status', type: 'select', icon: 'TextOutlined' },
//   { label: 'Sprint', key: 'sprint', type: 'text', icon: 'TextOutlined' },
//   { label: 'Attachments', key: 'attachments', type: 'file', icon: 'TextOutlined' },
//   { label: 'Priority', key: 'priority', type: 'select', icon: 'TextOutlined' },
//   { label: 'Epic', key: 'epic', type: 'text', icon: 'TextOutlined' },
//   { label: 'Module', key: 'module', type: 'text', icon: 'TextOutlined' },
//   { label: 'Component', key: 'component', type: 'text', icon: 'TextOutlined' },
//   { label: 'Spec Link', key: 'specLink', type: 'link', icon: 'TextOutlined' },
//   { label: 'Environment', key: 'environment', type: 'text', icon: 'TextOutlined' },
//   { label: 'Story Points', key: 'storyPoints', type: 'number', icon: 'TextOutlined' },
//   { label: 'Start Date', key: 'startDate', type: 'date', icon: 'TextOutlined' },
//   { label: 'End Date', key: 'endDate', type: 'date', icon: 'TextOutlined' },
//   { label: 'Start Time', key: 'startTime', type: 'datetime', icon: 'TextOutlined' },
//   { label: 'End Time', key: 'endTime', type: 'datetime', icon: 'TextOutlined' },
//   { label: 'Slot', key: 'slot', type: 'time-range', icon: 'TextOutlined' },
//   { label: 'Is Calendar', key: 'isCalendar', type: 'switch', icon: 'TextOutlined' },
//   { label: 'Release Version', key: 'releaseVersion', type: 'text', icon: 'TextOutlined' },
//   { label: 'Watchers', key: 'watchers', type: 'user-list', icon: 'TextOutlined' }
// ];

  